let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fRyXm")).then(() => parcelRequire('8aEuB'));